import * as React from 'react';
import styles from './Header.module.css';
import { ReactComponent as LogoMobile } from '../../svgMobile.svg';
type IProps = {
  title?: string;
  tagline?: string;
  image?: string;
  imageAlt?: string;
};

const Header: React.FC<IProps> = ({ title, tagline, image, imageAlt }) => (
  <>
    <header className={`${styles.header}${image ? ` ${styles.headerWithImage}` : ''}`}>
        <LogoMobile className={styles.header__logo} />
      {image && (
        <img className={styles.header__image} src={image} alt={imageAlt || ''} />
      )}
      <h1 className={styles.header__title}>{title}</h1>
      {tagline ? <p className={styles.header__tagline}>{tagline}</p> : null}
    </header>
    <div className={styles.wave}>
      <svg
        className={styles.wave__svg}
        viewBox="0 0 1440 120"
        width="100%"
        height="100%"
      >
        <path d="M1440,21.2101911 L1440,120 L0,120 L0,21.2101911 C120,35.0700637 240,42 360,42 C480,42 600,35.0700637 720,21.2101911 C808.32779,12.416393 874.573633,6.87702029 918.737528,4.59207306 C972.491685,1.8109458 1026.24584,0.420382166 1080,0.420382166 C1200,0.420382166 1320,7.35031847 1440,21.2101911 Z" />
      </svg>
    </div>
  </>
);

export default Header;
